export enum SectionNames {
  ERROR_SCREEN = 'error-screen',
  EXPIRED_SCREEN = 'expired-screen',
  TERMS_SCREEN = 'terms-screen',
  SINGLE_PAGE_HEADER = 'single-page-header',
  SINGLE_PAGE_GALLERY_VIEWER = 'single-page-gallery-viewer',
  SINGLE_PAGE_MENU = 'single-page-menu',
  SINGLE_PAGE_MODEL_PRICE_AND_FEATURES = 'single-page-model-price-and-features',
  SINGLE_PAGE_EXTERIOR_FEATURES = 'single-page-exterior-features',
  SINGLE_PAGE_INTERIOR_FEATURES = 'single-page-interior-features',
  SINGLE_PAGE_SPECIFICATIONS = 'single-page-specifications',
  SINGLE_PAGE_OPTIONAL_EXTRAS = 'single-page-optional-extras',
  SINGLE_PAGE_LIKED_ITEMS = 'single-page-liked-items',
  SINGLE_PAGE_YOUR_FINANCE_CALCULATION = 'single-page-your-finance-calculation',
  COMPARE_PAGE_YOUR_FINANCE_CALCULATION = 'compare-page-your-finance-calculation',
  COMPARE_PAGE_HEADER = 'compare-page-header',
  COMPARE_PAGE_VEHICLE_CARDS = 'compare-page-vehicle-cards',
  COMPARE_PAGE_EXTERIOR_FEATURES = 'compare-page-exterior-features',
  COMPARE_PAGE_INTERIOR_FEATURES = 'compare-page-interior-features',
  COMPARE_PAGE_MODEL_FEATURES = 'compare-page-model-features',
  COMPARE_PAGE_TECHNOLOGY_VIDEOS = 'compare-page-technology-videos',
  COMPARE_PAGE_MODEL_SPECIFICATIONS = 'compare-page-model-specifications',
  EVENT_BANNER = 'event-banner',
  SERVICE_PLAN_BANNER = 'service-plan-banner',
  FOOTER = 'footer',
}
